export const selectActivationModalState = ({ SubscriptionStore }) =>
  SubscriptionStore.activationModalState;

export const selectSubscription = ({ SubscriptionStore }) =>
  SubscriptionStore.subscription;
